import React from "react";
import Body from "../Common/Body";
import ContentCard from "../Common/Layout/ContentCard";
import OrdersTable from "./OrdersTable";
import StockTable from "./StockTable";

const Dashboard = () => {
  return (
    <Body title={"Home"}>
      <ContentCard>
        <OrdersTable />
      </ContentCard>
      <ContentCard>
        <StockTable />
      </ContentCard>
    </Body>
  );
};

export default Dashboard;
